import { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { PrimaryButton } from "@/components/StandardButton";
import { useNavigate } from "react-router-dom";

export const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 400px (past hero section)
      setIsVisible(window.scrollY > 400);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Respect reduced motion preference
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  if (!isVisible) return null;

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 ${
        prefersReducedMotion ? "" : "animate-fade-in"
      }`}
    >
      <PrimaryButton
        size="lg"
        className="shadow-md hover:shadow-lg transition-shadow gap-2"
        onClick={() => navigate("/auth?mode=signup")}
      >
        Start Free Trial
        <ArrowRight className="h-4 w-4" />
      </PrimaryButton>
    </div>
  );
};
